import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '977320251369577';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Avoid injecting twice
    if (document.getElementById('meta-pixel-base')) {
      window.fbq?.('track', 'PageView');
      return;
    }
    // Inject the canonical Meta Pixel base code as a real inline <script>
    // (so the Meta Pixel Helper can detect the init pattern + fbevents.js request)
    const script = document.createElement('script');
    script.id = 'meta-pixel-base';
    script.type = 'text/javascript';
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // <noscript> fallback image
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return null;
}